import { ISettings, SidebarManager } from 'web-core-src';
import { News } from 'web-core-src/pocos/news.class';

export enum ApplicationTheme {
    simplex = 'simplex',
    darkly = 'darkly',
    flatly = 'flatly',
}

export interface IWebCoreSettings extends ISettings {
    applicationShortNameSnakeCase: string;
    clientId: string;

    developerCompanyDomain: string;
    developerCompanyUrl: string;
    extensionFeedbackMailTo: string;
    developmentMailTo: string;

    developerPatreonUserName: string;
    developerKofiUserName: string;
    paypalHostedButtonId: string;

    applicationName: string;
    applicationShortName: string;

    applicationShortNameWithVersion: string;

    applicationTheme: string;
    applicationFacebookGroupUrl: string;
    applicationFacebookPageUrl: string;

    newsList: News[];
    lastNewsFetchAt: Date;

    sidebarManager: SidebarManager;
}
